import {Directive, Input} from '@angular/core';
import {Validator, AbstractControl, NG_VALIDATORS, ValidatorFn} from '@angular/forms';
import {Subscription} from 'rxjs';

@Directive({
    selector: '[compare]',
    providers: [{ provide: NG_VALIDATORS, useExisting: CompareValidatorDirective, multi: true }],
    standalone: false
})
export class CompareValidatorDirective implements Validator {
  @Input() controlName: string;

  // Template form user compare as directive
  validate(control: AbstractControl): { [key: string]: any } {
    const controlToCompare = control.root.get(this.controlName);
    if (controlToCompare) {
      const subscription: Subscription = controlToCompare.valueChanges.subscribe(() => {
        control.updateValueAndValidity();
        subscription.unsubscribe();
      })
    }
    return controlToCompare && controlToCompare.value !== control.value ? {'compare': true} : null;
  }
}

// Reactive form
export function compareValidator(controlName: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const controlToCompare = control.root.get(controlName);
    if (controlToCompare) {
      const subscription: Subscription = controlToCompare.valueChanges.subscribe(() => {
        control.updateValueAndValidity();
        subscription.unsubscribe();
      })
    }
    return controlToCompare && controlToCompare.value !== control.value ? {'compare': {value: control.value}} : null;
  };
}
